import { MarketData } from "../../../../interface/MarketData"

export const useMarketDetails = (marketData: MarketData[], tradingPair: string) => {
  return marketData.find(m => m.symbol === tradingPair)
}